import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SocialAuthService, FacebookLoginProvider, GoogleLoginProvider, SocialUser } from "angularx-social-login";
import { Router, ActivatedRoute } from '@angular/router';
import { Auth } from 'aws-amplify';
import { scaleIn } from '../../animations/modal.animation';

@Component({
  selector: 'app-header',
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [scaleIn]
})
export class HeaderComponent implements OnInit {

  public showMenu: boolean = false;

  @Input() pageName: any;

  _viewSignIn: any;
  toastr: any;
  @Input()
  get viewSignIn(): any { return this._viewSignIn; }
  set viewSignIn(viewLogin: any) {
    this._viewSignIn = viewLogin;

    this.displayLogin = this.viewSignIn;
  }

  _viewSignUp: boolean;
  @Input()
  get viewSignUp(): any { return this._viewSignUp; }
  set viewSignUp(viewReg: any) {
    this._viewSignUp = viewReg;

    this.displayReg = this.viewSignUp;
  };
  tokenExpirationTimer: any;

  @Output() closeAuthForms: EventEmitter<boolean> = new EventEmitter<boolean>(); //pass login forms status to home component
  @Output() displayLoginHome;
  isHidden: boolean = true;
  username: any;
  userAccessLevel: any;
  isPropertyOwner: boolean;
  user: string;
  displayReg: boolean;
  displayCallT: boolean;
  displayLogin: boolean;
  userMenu: boolean = false;
  signInMenu: boolean = false;
  displaySponsor: boolean = false;
  userGroup: any;
  loggedIn: any;
  social_user: SocialUser;
  fbLoginObj: any;
  expiredTime: any;
  issuedTime: any;
  validTokenTime: any;
  userNotAuthenticated: any;



  constructor(private router: Router, private ref: ChangeDetectorRef, private authService: SocialAuthService, private route: ActivatedRoute,) {

    //get current authenticated user
    this.getCurrentAuthenticatedUser();
    // this.AutoLogout(this.validTokenTime); 

  }

  signInWithGoogle(): void {
    this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  signInWithFB(): void {
    this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  signOutOfSocialProvider(): void {
    this.authService.signOut();
  }

  refreshToken(): void {
    this.authService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }

  ngOnInit() {

    if (!this.userNotAuthenticated) {
      this.AutoLogout((this.validTokenTime * 1000));
    }
    else if (this.userNotAuthenticated) {
      // console.log('userNotAuthenticated criteria not met. NO call !!!');   
      // this.AutoLogout(this.validTokenTime); 
    }


    (window as any).fbAsyncInit = function () {
      FB.init({
        appId: '136299118493147',
        cookie: true,
        xfbml: true,
        version: 'v3.1'
      });

      FB.AppEvents.logPageView();

    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }



  submitLogin() {
    FB.login((response) => {

      this.fbLoginObj = response.status;
      if (response.authResponse) {
        this.toastr.successToastr('Login successful', 'Success');
      }
      else {

        this.toastr.errorToastr('User Login Failed !');
      }
    })
  }


  getCurrentAuthenticatedUser() {
    this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.username = user.attributes.name + " " + user.attributes.family_name;
        this.isHidden = false;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        if (this.userGroup === 'properties') {
          this.isPropertyOwner = true;
        } else {
          this.isPropertyOwner = false;
        }
        this.expiredTime = user.signInUserSession.accessToken.payload.exp;
        this.issuedTime = user.signInUserSession.accessToken.payload.iat;
        this.validTokenTime = this.expiredTime - this.issuedTime;
      },
        (error) => {
          console.log("authentication error", error);
          this.userNotAuthenticated = error;

          this.isHidden = true;
        });
  }

  showDropdown() {
    this.userMenu = !this.userMenu;
  }

  showSignInDropdown() {
    this.signInMenu = !this.signInMenu;
  }

  closeDropdown() {
    this.userMenu = false;
  }

  onDisplayLogin() {
    this.displayLogin = true;
  }

  sponsorLogin() {
    this.displaySponsor = true;
  }

  onDisplaySignUp() {
    this.displayReg = true;
  }

  onDisplayCallT() {
    this.displayCallT = true;
  }

  close(event: any) {
    this.displayLogin = false;
    this.displayReg = false;
    // this.closeAuthForms.emit(this.displayLogin);
  }

  AutoLogout(expirationDuration: any) {
    this.tokenExpirationTimer = setTimeout(() => {
      this.signOut();
    }, expirationDuration);
  }


  // signOut() {
  //   sessionStorage.clear();

  //   Auth.signOut({ global: true })
  //     .then(data => {
  //       this.isHidden = true;

  //       this.router.navigateByUrl('/home');
  //       location.reload();
  //     })
  //     .catch(err => console.log('Err ::', err));

  //   if (this.tokenExpirationTimer) {
  //     clearTimeout(this.tokenExpirationTimer);
  //   }
  //   this.tokenExpirationTimer = null;
  //   // location.reload();
  // }

  async signOut() {
    try {
      await Auth.signOut();
      this.isHidden = true;
      this.isPropertyOwner = false;
      if (this.tokenExpirationTimer) {
        clearTimeout(this.tokenExpirationTimer);
      }
      this.tokenExpirationTimer = null;

      this.router.navigate(
        ['.'],
        { relativeTo: this.route, queryParams: {} }
      );
      this.router.navigateByUrl('/home');

      setTimeout(() => {
        location.reload();
      }, 200);
      this.router.navigate['/'];


    } catch (error) {
      console.log('error signing out: ', error);
    }
  }


  onRegister() {
    this.router.navigateByUrl('/reg-page');
  }

  onMenuClick() {
    this.showMenu = !this.showMenu;
  }

  onDisplayReg() {
    this.displayReg = true;
  }

  onShowRegister() {
    this.isHidden = false;
  }

  gotoValuations() {
    this.router.navigate(["/valuations"]);
  }

  gotoEvaluations() {
    this.router.navigate(["/view-sponsorship-applications"]);
  }

  goToOwnerEvaluations() {
    this.router.navigate(["/property-owner-applications"]);

  }

  goToPrivateSpace() {
    this.router.navigate(["/private-space/dashboard"]);
  }

  onEditProperty(property: any) {

    this.router.navigate(
      ['/properties/edit'],
      {
        relativeTo: this.route,
        queryParams: property,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }
}
